import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";
import type { ServiceInfo } from "./types";
import { SessionTime } from "./SessionTime";

export interface BookingSummaryData {
  service: ServiceInfo | null;
  dateLabel: string | null;
  /** Sarajevski "YYYY-MM-DD", za prikaz vremena posjetioca iz druge zone. */
  dateStr?: string | null;
  time: string | null;
  modalityLabel: string | null;
  paymentLabel: string | null;
}

function Row({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex items-start justify-between gap-3 border-b border-border py-2.5 last:border-b-0">
      <span className="text-[13px] text-muted-foreground">{label}</span>
      <span className="text-right text-[13.5px] font-medium text-foreground">{value}</span>
    </div>
  );
}

export function BookingSummary({ data }: { data: BookingSummaryData }) {
  const { t } = useTranslation();
  const rows: Array<[string, ReactNode]> = [];
  if (data.service) {
    rows.push([t("booking.summaryService"), data.service.name]);
    rows.push([t("booking.summaryDuration"), `${data.service.durationMinutes} min`]);
  }
  if (data.dateLabel) rows.push([t("booking.dateLabel"), data.dateLabel]);
  if (data.time) rows.push([t("booking.timeLabel"), <SessionTime dateStr={data.dateStr ?? null} time={data.time} />]);
  if (data.modalityLabel) rows.push([t("booking.sessionTypeLabel"), data.modalityLabel]);
  if (data.paymentLabel) rows.push([t("booking.paymentMethodLabel"), data.paymentLabel]);

  if (rows.length === 0) {
    return <p className="py-2 text-[13px] text-muted-foreground/70">{t("booking.summaryEmpty")}</p>;
  }
  return (
    <div>
      {rows.map(([label, value]) => (
        <Row key={label} label={label} value={value} />
      ))}
    </div>
  );
}
